import {useEffect, useRef, useState} from "react";
import FavouriteButton from "./FavouriteButton";

interface CrossSellProduct {
    id: number
    image: false | string
    is_favourite?: boolean
    link: string
    price: string
    sku: string
    title: string
}

interface CrossSellProps {
    products: CrossSellProduct[]
    title: string,
    columns: number
    loginRequired: boolean
    favouritesConfig?: {
        canToggle?: boolean;
        ajaxUrl?: string;
        nonce?: string;
        groupsEnabled?: boolean;
    }
}

const CrossSell: React.FC<CrossSellProps> = (props) => {
    const [itemIndex, setItemIndex] = useState(0);
    const [trackLeftCalculation, setTrackLeftCalculation] = useState(0)
    const crossSellTrackRef = useRef<HTMLDivElement>(null)
    const [itemColumns, setItemColumns] = useState<number>(props.columns)
    // Column gap between items applied as css
    const columnGap = 10

    const goLeft = () => {
        if (itemIndex > 0) {
            setItemIndex(itemIndex - 1)
        }
    }

    const goRight = () => {
        if (itemIndex < props.products.length - itemColumns) {
            setItemIndex(itemIndex + 1)
        }
    }

    useEffect(() => {
        if (crossSellTrackRef.current && crossSellTrackRef.current.children.length > 0) {
            const container = crossSellTrackRef.current.children;
            if (container[0]) {
                const items = container[0].children;
                const item = items[0]

                if (item) {
                    const itemWidth = item.getBoundingClientRect().width; // includes padding but not margin
                    const style = window.getComputedStyle(item);
                    const marginRight = parseFloat(style.marginRight) || 0;

                    const totalItemWidth = itemWidth + marginRight;

                    const newLeft = (itemIndex * (totalItemWidth)) + (itemIndex * 10);
                    setTrackLeftCalculation(-newLeft);
                }
            }
        }
    }, [itemIndex]);

    return (<div>
        <div className={'cross-sell-header'}>
            <h3>{props.title}</h3>
            <div className={'left-right-controls'}>
                <i className="fas fa-arrow-left" onClick={goLeft}></i>
                <i className="fas fa-arrow-right" onClick={goRight}></i>
            </div>
        </div>
        <div className={'product-cross-sell-track'} ref={crossSellTrackRef}>
            <div className={'product-cross-sell-container'} style={{transform: 'translateX(' + trackLeftCalculation + 'px)', gap: columnGap + 'px'}}>
                {props.products && props.products.map && props.products.map((product, index) => {
                    return <div
                        key={product.id}
                        className={'product-cross-sell-item' + (index < itemIndex ? ' outside' : '') + (index >= (itemIndex + itemColumns) ? ' outside' : '')}
                        style={{minWidth: 'calc(' + (100 / itemColumns) + '% - ' + (columnGap) + 'px)'}}>
                        <div className={'product-image'}>
                            <img src={(product.image !== false ? product.image : 'https://placehold.co/600x400')}
                                 alt={'product ' + product.sku}/>
                        </div>
                        <a href={product.link} className={'product-title'}>{product.title}</a>
                        <p dangerouslySetInnerHTML={{__html: product.price}} className={'product-price'}></p>
                        {!props.loginRequired && (
                            <a href={'/?add-to-cart=' + product.id + '&quantity=1&redirect_to=' + encodeURIComponent(window.location.href)} className={'button weka-primary-btn'}>Add to cart</a>
                        )}
                        <FavouriteButton
                            productId={product.id}
                            initialIsFavourite={product.is_favourite === true}
                            displayMode={'compact'}
                            className={'button weka-secondary-btn'}
                            canToggle={props.favouritesConfig?.canToggle}
                            ajaxUrl={props.favouritesConfig?.ajaxUrl}
                            nonce={props.favouritesConfig?.nonce}
                            groupsEnabled={props.favouritesConfig?.groupsEnabled}
                        />
                    </div>
                })}
            </div>
        </div>
    </div>)
}

export default CrossSell
